import React, { useState } from "react";
import { Button, Form, Input, TimePicker, Typography, Row, Col } from "antd";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  addShift,
  loadAllShiftPaginated,
} from "../../../redux/rtk/features/hrm/shift/shiftSlice";

const { Title, Text } = Typography;

export default function AddShift() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    const start = values.startTime;
    const end = values.endTime;

    if (!start || !end) {
      toast.dismiss();
      toast.error("Please select both Start and End time.");
      return;
    }
    if (!end.isAfter(start)) {
      toast.dismiss();
      toast.error("End time must be later than Start time.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        name: values.name,
        startTime: start.format("HH:mm"),
        endTime: end.format("HH:mm"),
      };

      const resp = await dispatch(addShift(payload));
      if (resp?.payload?.message === "success") {
        toast.dismiss();
        toast.success("Shift created successfully!");
        form.resetFields();
        dispatch(loadAllShiftPaginated({}));
      } else {
        toast.dismiss();
        toast.error("Failed to create shift.");
      }
    } catch {
      toast.dismiss();
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="text-center mb-6 px-2">
        <Title level={3} style={{ marginBottom: 4 }}>
          Create Shift
        </Title>
        <Text type="secondary">Define working hours for a shift.</Text>
      </div>

      <Form
        form={form}
        name="add-shift"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        requiredMark={false}
        className="px-2 sm:px-6"
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={18} md={16}>
            <Form.Item
              label="Shift Name"
              name="name"
              rules={[{ required: true, message: "Please enter shift name!" }]}
            >
              <Input placeholder="e.g. Morning Shift" size="large" />
            </Form.Item>
          </Col>
        </Row>

        {/* Time pickers: stack on mobile, side-by-side on sm+ */}
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Start Time"
              name="startTime"
              rules={[{ required: true, message: "Please select start time!" }]}
            >
              <TimePicker format="HH:mm" size="large" className="w-full" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="End Time"
              name="endTime"
              rules={[{ required: true, message: "Please select end time!" }]}
            >
              <TimePicker format="HH:mm" size="large" className="w-full" />
            </Form.Item>
          </Col>
        </Row>

        {/* Submit: full-width on mobile, compact on desktop */}
        <div className="mt-2 flex justify-end">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
            className="w-full sm:w-auto"
          >
            Create Shift
          </Button>
        </div>
      </Form>
    </>
  );
}
